import { showErrorMessage } from "../../common/Toaster";
import jwtAxios from "../../services/axiosInstance/ApiConfig";
import { categoriesResponse, subCategoryresponse } from "../../services/dbs/bazzarey_dbs";
import { SET_ALL_CATEGORY, SET_ALL_SUBCATEGORY } from "../types/actions/ProductAction";

export const onGetAllCategories = () => {
	return async (dispatch: any) => {
		try {
			const resp = await jwtAxios.get('/category/get-categories')
			if (resp && resp.status === 200) {
                dispatch({ type: SET_ALL_CATEGORY, payload: resp.data })
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			console.log("err ", err)
			if(err.code === 'ERR_NETWORK')
				dispatch({ type: SET_ALL_CATEGORY, payload: categoriesResponse })
			else
				showErrorMessage(err)
		}
	};
};

export const onGetAllSubCategories = () => {
	return async (dispatch: any) => {
		try {
			const resp = await jwtAxios.get('/subcategory/get-subcategories')
			if (resp && resp.status === 200) {
                dispatch({ type: SET_ALL_SUBCATEGORY, payload: resp.data })
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			console.log("err ", err)
			if(err.code === 'ERR_NETWORK')
				dispatch({ type: SET_ALL_CATEGORY, payload: subCategoryresponse })
			else
				showErrorMessage(err)
		}
	};
};
